import { nativeSelectAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const nativeSelectSlotRecipe = defineSlotRecipe({
  className: 'native-select',
  slots: [...nativeSelectAnatomy.keys(), 'statusIcon'],
  base: {
    root: {
      position: 'relative',
    },
    field: {
      width: '100%',
      minWidth: 0,
      appearance: 'none',
      cursor: 'pointer',
      borderRadius: '4',
      borderWidth: '1',
      borderColor: 'border/strong',
      background: 'background/primary',
      transition: '200ms',
      color: 'input/text/inputValue',
      paddingInlineEnd: '48',
      _hover: {
        borderColor: 'border/hover',
        _invalid: {
          borderColor: 'border/error',
        },
      },
      _invalid: {
        borderColor: 'border/error',
      },
      _placeholderShown: {
        color: 'input/text/placeholder',
      },
      _disabled: {
        _hover: {
          borderColor: 'border/disabled',
        },
        borderColor: 'border/disabled',
        color: 'text/disabled',
        background: 'background/disabled',
        cursor: 'not-allowed',
      },
      _readOnly: {
        _hover: {
          borderColor: 'border/strong',
        },
        background: 'background/disabled',
        cursor: 'default',
      },
    },
    statusIcon: {
      position: 'absolute',
      top: '50%',
      right: '48',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
    },
    indicator: {
      position: 'absolute',
      top: '50%',
      right: rem(15),
      transform: 'translateY(-50%)',
    },
  },
  variants: {
    hasStatusIcon: {
      true: {
        field: { paddingInlineEnd: '96' },
      },
      false: {},
    },
    size: {
      md: {
        field: { paddingInlineStart: rem(11), paddingBlock: rem(9), textStyle: 'body/md/regular' },
      },
      lg: {
        field: { paddingInlineStart: rem(15), paddingBlock: rem(11), textStyle: 'body/lg/regular' },
      },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default nativeSelectSlotRecipe;
